import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from 'Common/Components/Checkbox';
import { get } from 'lodash';
import Skeleton from 'Common/Components/Skeleton';
import { multipleAgentExecutionSetSelected, selectAllAgentExecutions, unselectAgentExecution, unselectAllAgentExecutions } from 'store/Agents/actions';
import { selectAgentExecutions, selectAgentExecutionSelected } from 'store/Agents/selectors';

const SelectedCell = ({ rowInfo, isHeader, showSkeleton, disabled }) => {
  const dispatch = useDispatch();
  const data = get(rowInfo, 'original', {});
  const rowId = get(rowInfo, 'original.id', '');
  const agentExecutions = useSelector(selectAgentExecutions);
  const agentExecutionsSelected = useSelector(selectAgentExecutionSelected);
  const isSelected = agentExecutionsSelected.some((e) => e.id === rowId);

  const allRowsSelected = agentExecutions.length === agentExecutionsSelected.length;

  const rowClick = () => {
    if (isSelected) dispatch(unselectAgentExecution(data));
    else dispatch(multipleAgentExecutionSetSelected(data));
  };

  const headerClick = () => {
    if (allRowsSelected) {
      dispatch(unselectAllAgentExecutions());
    } else {
      dispatch(selectAllAgentExecutions());
    }
  };

  const onClick = isHeader ? headerClick : rowClick;

  if (showSkeleton) return <Skeleton />;
  return (
    <Checkbox disabled={ disabled } theme="grey" onChange={ onClick } state={ isHeader ? allRowsSelected : isSelected } partialChecked={ isHeader && !allRowsSelected && agentExecutionsSelected?.length > 0 } />
  );
};

export default SelectedCell;
